namespace SSi.Blazor.Common.Shared.Wasm.Localforage {

    export function createInstance(dbName: string, storeName: string): any {
        const options = {
            name: dbName,
            storeName: storeName
        };

        if (dbName === "" || storeName === "") {
            return (window as any).localforage.createInstance();
        } else {
            return (window as any).localforage.createInstance(options);
        }
    }

    export function getDefaultStore(): any {
        return (window as any).localforage;
    }

    export function dropInstanceStore(instance: any): boolean {
        instance.dropInstance().then(() => {
            console.debug('Dropped the store of the current instance');
            return true;
        }).catch(err => {
            // This code runs if there were any errors
            console.error(err);
            return false;
        });
        return false;
    }

    export function dropDbStoreInstance(dbName: string, storeName: string): boolean {
        const options = {
            name: dbName,
            storeName: storeName
        };

        (window as any).localforage.dropInstance(options).then(() => {
            console.debug(`Dropped database: ${dbName} table ${storeName}`);
            return true;
        }).catch(err => {
            // This code runs if there were any errors
            console.error(err);
            return false;
        });
        return false;
    }

    export function dropDbInstance(dbName: string): boolean {
        const options = {
            name: dbName
        };

        (window as any).localforage.dropInstance(options).then(() => {
            console.debug(`Dropped database: ${dbName}`);
            return true;
        }).catch(err => {
            // This code runs if there were any errors
            console.error(err);
            return false;
        });
        return false;
    }

    //export function getItem(instance: any, keyName: string): string {
    export async function getItem(instance: any, keyName: string): Promise<string> {
        //console.debug(`instance name=${instance._config.name} storeName=${instance._config.storeName} getItem(${keyName})`);

        try {
            const value = await instance.getItem(keyName);
            // This code runs once the value has been loaded
            // from the offline store.
            //console.debug(`${keyName}=${value}`);
            return value;
        } catch (err) {
            // This code runs if there were any errors.
            console.error(err);
            return "";
        }
        return "";
    }

    export function setItem(instance: any, keyName: string, value: string): boolean {
        instance.setItem(keyName, value).then(valueX => {
            // Do other things once the value has been saved.
            //console.debug(valueX);
            return true;
        }).catch(err => {
            // This code runs if there were any errors
            console.error(err);
            return false;
        });

        return false;
    }

    export function removeItem(instance: any, keyName: string): boolean {
        instance.removeItem(keyName).then(() => {
            // Run this code once the database has been entirely deleted.
            //console.debug('Key is cleared!');
            return true;
        }).catch(err => {
            // This code runs if there were any errors
            console.error(err);
            return false;
        });

        return false;
    }


    export function clear(instance: any): boolean {
        instance.clear().then(() => {
            // Run this code once the database has been entirely deleted.
            console.debug('Database is now empty.');
            return true;
        }).catch(err => {
            // This code runs if there were any errors
            console.error(err);
            return false;
        });

        return false;
    }


    export function getKey(instance: any, keyIndex: number): string {
        instance.key(keyIndex).then(value => {
            // This code runs once the value has been loaded from the offline store.
            //console.debug(value);
            return value;
        }).catch(err => {
            // This code runs if there were any errors
            console.error(err);
            return "";
        });

        return "";
    }

    export async function getKeys(instance: any): Promise<string[]> {
        try {
            const value = await instance.keys();
            //console.debug(`getKeys=${value}`);
            if (value != null) {
                return value;
            }
        } catch (err) {
            // This code runs if there were any errors.
            console.error(err);
            return Array<string>();
        }
        return Array<string>();
    }


    export async function getLength(instance: any): Promise<number> {
        try {
            const value = await instance.length();
            //console.log(value);
            return value;
        } catch (err) {
            // This code runs if there were any errors.
            console.log(err);
            return 0;
        }
    }


    //export function containsKey(instance: any, keyName: string): boolean {
    //    instance.getItem(keyName).then(value => {
    //        // This code runs once the value has been loaded from the offline store.
    //        //console.debug(value);
    //        if (value == null || value == undefined) {
    //            return false;
    //        } else {
    //            return `${value}`.length > 0;
    //        }
    //    }).catch(err => {
    //        // This code runs if there were any errors
    //        console.error(err);
    //        return false;
    //    });

    //    return false;
    //}



}

